import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
import type { AccessAction } from '../constants/sidebar-access';

/** Show the template only when the signed-in user has feature:action (default view). */
@Directive({ selector: '[appAccess]' })
export class AccessDirective implements OnDestroy {
  private feature = '';
  private action: AccessAction = 'view';
  private visible = false;
  private readonly sub: Subscription;

  constructor(
    private template: TemplateRef<unknown>,
    private view: ViewContainerRef,
    private permissions: PermissionService,
    auth: AuthService,
  ) {
    this.sub = auth.userChanges$.subscribe(() => this.render());
  }

  @Input() set appAccess(value: string) {
    const [feature, action] = String(value || '').split(':');
    this.feature = feature || '';
    this.action = (action || 'view') as AccessAction;
    this.render();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private render(): void {
    const allowed = !!this.feature && this.permissions.can(this.feature, this.action);
    if (allowed && !this.visible) {
      this.view.createEmbeddedView(this.template);
      this.visible = true;
    } else if (!allowed && this.visible) {
      this.view.clear();
      this.visible = false;
    }
  }
}
